var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-small is-info is-outlined",class:{ 'is-loading': _vm.loading },attrs:{"type":"button","disabled":!_vm.offerId || _vm.loading,"data-test":"greetings-suggestion-button"},on:{"click":function($event){$event.stopPropagation();return _vm.fetchSuggestion.apply(null, arguments)}}},[_vm._v("הצעת פתיח לפי כישורים")])
}
var staticRenderFns = []

export { render, staticRenderFns }